import { createSelector } from '@ngrx/store';
import { CollectionsState, getCollectionsState } from '../collections.reducer';
import { candidatesAdapter, CandidatesState } from './candidates.reducer';
import { getPaginationSelectors } from '@app/shared/pagination-adapter/pagination-adapter';
import { Candidate } from '@app/shared/models/candidate';

export const getCandidatesState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.candidates,
);

export const {
  isLoaded: getCandidatesLoaded,
  paginationData: getCandidatesPaginationData,
  getEntities: getCandidatesList,
} = getPaginationSelectors<CandidatesState, Candidate>(getCandidatesState);

export const { selectAll: getCandidatesListAll } =
  candidatesAdapter.getSelectors(getCandidatesList);

export const getCandidatesTotalPagesNumber = createSelector(
  getCandidatesPaginationData,
  (state) => state?.totalPages ?? 0,
);

export const getCandidatesCurrentPageNumber = createSelector(
  getCandidatesPaginationData,
  (state) => state?.number ?? 0,
);

export const getCandidatesLastPage = createSelector(
  getCandidatesPaginationData,
  (state) => state?.last ?? true,
);

export const getCandidatesPageLoading = createSelector(
  getCandidatesPaginationData,
  (state) => state?.loading ?? false,
);

export const getCandidatesPageSettled = createSelector(
  getCandidatesLoaded,
  getCandidatesPageLoading,
  (isLoaded, isLoading) => isLoaded && !isLoading,
);

export const selectCandidateSummary = (candidateId: string) =>
  createSelector(getCandidatesState, (state) => state.candidateSummaries[candidateId]);

export const selectStatusSelected = createSelector(getCandidatesState, (state) => state?.statusId);
